import React, {useRef, useState} from "react";
import {GroupedPackageItem} from "types/entities/GroupedPackageItem";
import GroupedPackageUpsellItemItem from "pages/Front/Booking/components/PackageUpsell/GroupedPackageUpsellItemItem";
import {ServerImage} from "components/ServerImage";
import {getSelectedUpsell, translate} from "utils/utility";
import GroupedPackageUpsellItemOpenButton from "pages/Front/Booking/components/PackageUpsell/components/GroupedPackageUpsellItemOpenButton";
import clsx from "clsx";
import {useTypedSelector} from "helpers/reducers";

interface GroupedPackageUpsellItemProps {
    item: GroupedPackageItem;
    isSeller?: boolean;
}

const GroupedPackageUpsellItem = (props: GroupedPackageUpsellItemProps) => {
    const bookingProcess = useTypedSelector(state => state.bookingState.bookingProcess);
    const isAnyUpsellSelected = props.item.items.some(packageItem => {
        return getSelectedUpsell(bookingProcess.upsell, packageItem) !== undefined;
    });
    const [isOptionsOpen, setIsOptionsOpen] = useState<boolean>(isAnyUpsellSelected);
    const contentRef = useRef<HTMLDivElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    const handleToggle = () => {
        setIsOptionsOpen(!isOptionsOpen);

        // if (!isOptionsOpen && containerRef.current) {
        //     const scrollableParent = containerRef.current.closest(".scrollable-parent") as HTMLElement;
        //
        //     if (scrollableParent) {
        //         scrollableParent.scrollTo({
        //             top: containerRef.current.offsetTop - scrollableParent.offsetTop,
        //             behavior: "smooth",
        //         });
        //     } else {
        //         containerRef.current.scrollIntoView({
        //             behavior: "smooth",
        //             block: "start",
        //         });
        //     }
        // }
    };

    return (
        <div className={"GroupedPackageUpsellItem overflow-hidden w-full flex flex-col bg-white rounded-xl shadow"} ref={containerRef}>
            <div className={"w-full flex flex-col md:flex-row md:items-stretch"}>
                <div className={"flex flex-row w-full md:w-auto md:self-stretch md:flex-1"}>
                    <div
                        className={clsx(
                            "grow flex flex-col md:items-stretch w-full max-w-full",
                            props.isSeller ? "sm:w-[128px] sm:max-w-[128px]" : "md:w-[16rem] md:max-w-[16rem] h-full"
                        )}
                    >
                        <div
                            className={clsx(
                                "itemImage flex h-full overflow-hidden w-full grow rounded-t-lg md:rounded-tr-none",
                                props.isSeller ? "sm:max-w-[128px] aspect-auto" : "md:max-h-full aspect-[64/56] sm:max-h-[250px] md:max-w-[16rem]"
                            )}
                        >
                            {props.item?.packageItemVariant && props.item.packageItemVariant?.image && props.item.packageItemVariant.image !== "" && (
                                <ServerImage
                                    alt={"Package Item Image"}
                                    className={"w-full md:max-h-auto object-cover object-center"}
                                    src={props.item.packageItemVariant.image}
                                />
                            )}
                        </div>
                    </div>
                </div>

                <div
                    className={clsx(
                        "w-full text-black flex flex-col items-start justify-center",
                        props.isSeller ? "pl-2 pr-2 py-2 gap-y-1" : "px-4 lg:px-8 py-4 gap-y-2 md:gap-y-0"
                    )}
                    data-package-item-id={props.item.variant_id}
                >
                    <h3 className="text-black leading-tight text-base sm:text-xl lg:text-xl xl:text-2xl text-left font-bold flex-grow w-full">
                        {props.item?.packageItemVariant ? translate(props.item.packageItemVariant.name) : translate(props.item.name)}
                    </h3>

                    {props.item?.packageItemVariant && (
                        <div className={"flex justify-center items-center h-full w-full text-black text-xs sm:text-sm lg:text-base font-medium"}>
                            {props.item?.packageItemVariant.description_html ? (
                                <p className={"w-full"} dangerouslySetInnerHTML={{__html: translate(props.item?.packageItemVariant.description_html)}} />
                            ) : (
                                <p className={"w-full"}>{translate(props.item?.packageItemVariant.description)}</p>
                            )}
                        </div>
                    )}
                </div>

                <GroupedPackageUpsellItemOpenButton
                    className={"!hidden md:!flex"}
                    handleToggle={handleToggle}
                    isOptionsOpen={isOptionsOpen}
                    isSeller={props.isSeller}
                />
            </div>

            <div
                className={
                    "flex flex-col items-center justify-between w-full divide-y overflow-hidden transition-[max-height] duration-500 ease-in-out transform-gpu will-change-auto"
                }
                style={{
                    maxHeight: isOptionsOpen ? `${contentRef.current?.scrollHeight}px` : "0px",
                }}
                ref={contentRef}
            >
                {props.item.items.map((packageItem, index) => (
                    <GroupedPackageUpsellItemItem key={index} packageItem={packageItem} isSeller={props.isSeller} />
                ))}
            </div>

            <GroupedPackageUpsellItemOpenButton
                className={clsx("!flex md:!hidden", isOptionsOpen && "border-t md:border-t-0")}
                handleToggle={handleToggle}
                isOptionsOpen={isOptionsOpen}
                isSeller={props.isSeller}
            />
        </div>
    );
};

export default GroupedPackageUpsellItem;
